import { render, staticRenderFns } from "./Annotation.vue?vue&type=template&id=1b122c93"
import script from "./Annotation.vue?vue&type=script&lang=ts"
export * from "./Annotation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b122c93')) {
      api.createRecord('1b122c93', component.options)
    } else {
      api.reload('1b122c93', component.options)
    }
    module.hot.accept("./Annotation.vue?vue&type=template&id=1b122c93", function () {
      api.rerender('1b122c93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Annotation.vue"
export default component.exports